import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Card: any = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  padding: 16px;
  background-color: ${ColorPalette.HEX.White};
  border-radius: 12px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.PineTree}, 0.16);
  margin: 0 16px 16px;
  @media ${({ theme }) => theme.device.desktop} {
    width: 100%;
    margin: 0 0 16px;
  }
`;

Card.Image = styled.div`
  width: 100px;
  height: 100px;
  border: 1px solid ${ColorPalette.HEX.BrightGray6};
  border-radius: 12px;
  background-color: ${ColorPalette.HEX.White};
  overflow: hidden;
  position: relative;
  margin-right: 16px;
`;

Card.Logo = styled.div`
  width: 44px;
  height: 16px;
  position: absolute;
  top: 11px;
  left: 11px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top left;
`;

Card.Photo = styled.div`
  width: 98px;
  height: 72px;
  position: absolute;
  bottom: 0;
  right: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

Card.AutoInfo = styled.div`
  margin: 2px 0 3px;
`;

Card.Text = styled.div`
  min-height: 92px;

  & p {
    text-align: left;
    padding: 12px 16px;
    font-size: 14px;
    margin: 0;
    white-space: normal;
  }
`;

export const Content = styled.div`
  margin-right: 16px;
  text-align: left;
  width: calc(100% - 132px);
  position: relative;
`;

export const Title = styled.h4`
  font-weight: 600;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.4em;
`;

export const Subtitle = styled.h5`
  font-weight: 400;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.4em;
`;

export const Price: any = styled.div``;

Price.Total = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.6em;
`;
Price.Info = styled.div`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
  line-height: 1.2em;
`;
Price.Policy = styled.div`
  font-size: 12px;
  line-height: 1.2em;
  margin-top: 10px;
  padding-bottom: 4px;
`;

export const StyledButton = styled(Button)`
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: -16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding-top: 2px;
  color: ${ColorPalette.HEX.White};
  display: flex;
  justify-content: center;
  align-items: center;
  & svg.icons {
    color: ${ColorPalette.HEX.White};
  }
`;

export const Valid = styled.span`
  color: ${ColorPalette.HEX.GreenPantone};
  font-size: 12px;
`;

export const Invalid = styled.span`
  color: ${ColorPalette.HEX.RedRYB};
  font-size: 12px;
`;
